import type { AuthUser } from './store';

function normalizeEmail(email: string | null | undefined) {
  return email?.trim().toLowerCase() ?? '';
}

export function resolveAccountEmail(user: AuthUser | null): string {
  const primary = normalizeEmail(user?.primaryEmail);
  if (primary) return primary;

  const emailIdentity = user?.identities.find(
    (identity) => identity.provider === 'supabase_email' && identity.emailNormalized,
  );

  return normalizeEmail(emailIdentity?.emailNormalized);
}
